import { globalPropsMap } from './inappGlobalPropsMetric';
function getValue(key) {
    var _a, _b, _c;
    let globalProps;
    try {
        // eslint-disable-next-line @ttfe/@typescript-eslint/no-unnecessary-condition
        const globalPropsString = (_a = window.__globalprops) === null || _a === void 0 ? void 0 : _a.getGlobalProps();
        globalProps = JSON.parse(globalPropsString);
        if (!globalProps) {
            throw new Error('no globalProps');
        }
        const result = globalPropsMap[key].query(globalProps);
        return result;
    }
    catch {
        try {
            //not spark container;
            const result = (_c = (_b = globalPropsMap[key]).fallback) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (result) {
                return result;
            }
        }
        catch {
            //do nothing
        }
        return {
            isResolved: true,
            val: undefined,
        };
    }
}
const subMap = {};
function onGlobalPropsUpdate() {
    for (const cb of Object.values(subMap)) {
        cb();
    }
}
function subscribe(cb, name) {
    const id = `sub_${name}_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
    subMap[id] = cb;
    return id;
}
function unsubscribe(id) {
    if (id) {
        delete subMap[id];
    }
}
export async function getGlobalProps(key) {
    if (globalPropsMap[key].value.isResolved) {
        return globalPropsMap[key].value.promise;
    }
    const value = getValue(key);
    if (value.isResolved) {
        globalPropsMap[key].value.resolve(value.val);
    }
    else {
        const id = subscribe(() => {
            const newValue = getValue(key);
            if (newValue.isResolved) {
                globalPropsMap[key].value.resolve(newValue.val);
                unsubscribe(id);
            }
        }, key);
    }
    return globalPropsMap[key].value.promise;
}
export function getGlobalPropsSync(key) {
    if (!globalPropsMap[key].value.isResolved) {
        const value = getValue(key);
        if (value.isResolved) {
            globalPropsMap[key].value.resolve(value.val);
        }
    }
    return globalPropsMap[key].value.resolvedValue;
}
export function startGlobalPropsMonitor(jsbClient) {
    try {
        jsbClient.on('globalPropsUpdated', onGlobalPropsUpdate);
    }
    catch {
        //do nothing
    }
}
export function resetGlobalPropsValues() {
    Object.values(globalPropsMap).forEach((model) => {
        model.value.reset();
    });
}
//# sourceMappingURL=inappGlobalProps.js.map